import './style/App.css';
import { Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Destination from './pages/Destination';
import Crew from './pages/Crew';
import Technology from './pages/Technology';
import Navbar from './components/Navbar';


function App() {
  let location = useLocation();

  function changeBackground(){
    if(location.pathname === '/'){
      document.body.className = 'home-body';
    }else if(location.pathname === '/destination'){
      document.body.className = 'destination-body';
    }else if(location.pathname === '/crew'){
      document.body.className = 'crew-body';
    }else{
      document.body.className = 'technology-body';
    }
  }

  changeBackground();

  return (
    <div>
      <Navbar/>
      <Routes>
        <Route path='/' element={<Home />}></Route>
        <Route path='destination' element={<Destination/>}></Route>
        <Route path='crew' element={<Crew />}></Route>
        <Route path='technology' element={<Technology />}></Route>
      </Routes>
    </div>
  );
}

export default App;
